import React, { Component } from 'react';
import YesButton from '../../../../../common/button/answerButton/yesButton/yesButton';
import NoButton from '../../../../../common/button/answerButton/noButton/noButton';
import './question.scss';
class Question extends Component {

    state = {
        className : 'test-to-show second-test',
        attributes:{},
        automaticAnswer : false
    }

    componentDidMount(){
        // const userAnswers = this.props.userAnswers;
        const timeOut = this.props.timeOut;
        const timetoShow = this.props.timetoShow;
        let attributes = {};
        attributes.correct = this.props.correct
        setTimeout(()=>{
            let className = this.state.className;
            className += ' hidden';
            this.setState({className});
        },timetoShow);

        let automaticAnswer = this.state.automaticAnswer;
        setTimeout(()=>{
            automaticAnswer = true;
            this.setState({automaticAnswer});
        },timeOut);

    }

    updateAutomatic = () =>{
        let automaticAnswer = true;
        this.setState({automaticAnswer});
    }

    answerVariant = (variant) =>{
        switch (variant) {
            case '1' : return false; break;
            case '2' : return false; break;
            case '3' : return false; break;
            case '4' : return true; break;
            case '5' : return true; break;
            default : return true;
        }
    }

    render() {

        let startTime = new Date();
        let timeOut = this.props.timeOut;
        const {symbol, symbo2, variant} = {...this.props};
        console.log(variant)
        let realAnswer = this.answerVariant(variant);
        let automaticAnswer = this.state.automaticAnswer;
        return (
            <React.Fragment>
                <div className={this.state.className} >
                    <div className="symbol-holder">
                        <p className="symbol">{symbol}</p>
                        <p className="symbol">{symbo2}</p>
                    </div>
                </div>
                <div className="buttons">
                    <button
                        className="answer-buttons"
                        onClick={() => {
                            this.props.fillAnswer(
                                'Yes',
                                startTime,
                                realAnswer,
                                automaticAnswer,
                                symbol,
                                symbo2,
                                variant                        
                            );
                        }}
                    >
                        ორივე სიტყვაა
                    </button>
                    <button
                        className="answer-buttons"
                        onClick={() => {
                            this.props.fillAnswer(
                                'No',
                                startTime,
                                realAnswer,
                                automaticAnswer,
                                symbol,
                                symbo2,
                                variant                          
                            );
                        }}
                    >
                        ერთი ან ორივე არ არის სიტყვა
                    </button>
                </div>
            </React.Fragment>
            
        );
    }
}

export default Question;